import React from 'react';
import styled from 'styled-components';

import { usePriceRowContext } from 'src/areas/product/components/price-list/price-row-context';

import { layout } from '@prisjakt/ui-base';

import AlternativePriceRow from '../../row-types/alternative-price-row';
import { ReportButton } from '../report-button';
import { StoreInfo } from '../store-info';

import { AlternativePrice, Award } from 'src/types';
import { ReportRowType, ITableLinkProps } from '../../types';

import { Modal } from 'src/areas/product/styles';
import { AltReportRow, Column } from '../../row-types/styles';

type Props = {
  alternativePrices?: (AlternativePrice | null)[] | null;
  closeModal: () => void;
  closeReportOverlay: () => void;
  isOpen: boolean;
  priceRowReport: ReportRowType;
  reportRowId: string | null;
  sotyBadge?: Award | null;
  tableLinkProps: ITableLinkProps;
};

export const InfoModal = (props: Props) => {
  const { isFeatured } = usePriceRowContext();

  const {
    alternativePrices,
    closeModal,
    closeReportOverlay,
    isOpen,
    priceRowReport,
    reportRowId,
    sotyBadge,
    tableLinkProps,
  } = props;

  return (
    <StyledModal
      isOpen={isOpen}
      onRequestClose={closeModal}
      shouldShowCloseIcon
      width={526}
    >
      <StyledContainer>
        <StoreInfo sotyBadge={sotyBadge} />
        {alternativePrices && isFeatured ? (
          <div>
            {alternativePrices.map(altPrice => {
              if (!altPrice) return null;

              return (
                <AlternativePriceRowWrapper
                  key={altPrice.id || 'alternative-price-row'}
                >
                  <AlternativePriceRow
                    alternativeOffer={altPrice}
                    tableLinkProps={tableLinkProps}
                  />
                  {priceRowReport === ReportRowType.ALTERNATIVE &&
                    reportRowId === altPrice.id && (
                      <AltReportRow>
                        <Column>
                          <ReportButton
                            priceId={altPrice.id}
                            priceValue={
                              altPrice.price && altPrice.price.exclShipping
                            }
                            stockStatus={
                              altPrice.stock && altPrice.stock.status
                            }
                            onClose={closeReportOverlay}
                            productName={altPrice.name}
                          />
                        </Column>
                      </AltReportRow>
                    )}
                </AlternativePriceRowWrapper>
              );
            })}
          </div>
        ) : null}
      </StyledContainer>
    </StyledModal>
  );
};

const StyledModal = styled(Modal)`
  && {
    overflow-y: scroll;
    max-height: 90vh;
  }
`;

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: ${layout.measurements.spacing100};
`;

const AlternativePriceRowWrapper = styled.div`
  margin-bottom: ${layout.measurements.spacing050};
`;
